import {
  Module,
  VuexModule,
} from 'vuex-module-decorators';
import config from '@/settings/config';

@Module({
  namespaced: true,
})
class OriginatorModule extends VuexModule {
  get getOriginator() {
    return config.originator;
  }

  get getWalletCurrency() {
    return config.originatorCurrency;
  }
}

export default OriginatorModule;
